import styled from 'styled-components';
import { icons } from '../../../icons';
import { TENANT_NAME } from '../../../config/tenants';
import { ReactComponent as InterriskErrorLocationIcon } from '../../../icons/interrisk/error-location.svg';
import { ReactComponent as TuwErrorLocationIcon } from '../../../icons/tuw/error-location.svg';

const iconBasedOnTenant = icons[TENANT_NAME];

export const SuccessPageTimeSpeedIcon = styled(iconBasedOnTenant.TimeSpeed)`
  width: clamp(7.2rem, 10vw, 10rem);
`;

export const ErrorLicensePlatesIcon = styled(iconBasedOnTenant.ErrorLicensePlates)`
  width: clamp(7.2rem, 10vw, 10rem);
`;

export const ErrorLocationInterrisk = styled(InterriskErrorLocationIcon)`
  width: clamp(7.2rem, 10vw, 10rem);
`;

export const ErrorLocationTuw = styled(TuwErrorLocationIcon)`
  width: clamp(7.2rem, 10vw, 10rem);
`;
